import React from "react";

const Start = ({ path }) => (
  <div className="start">
    <a href={path} title="Restart the slider" >
      <i className="p-1/2 my-float">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="black"
          className="bi bi-skip-backward-fill"
          viewBox="0 0 16 16"
        >
          <path d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z" />
        </svg>
      </i>
    </a>
  </div>
);
export default Start;
